
function Story() {
  return (
    <section className="py-16 md:py-24 lg:py-32">
      <div className="container">
        <div className="flex justify-center">
          <div className="w-full lg:w-11/12">
          <div className="cont pb-12 md:pt-16 border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
                <div className="md:col-span-3 mb-8 md:mb-0">
                  <h6 className="text-xl md:text-2xl lg:text-3xl font-semibold text-gray-800">The Story</h6>
                </div>
                <div className="md:col-span-9">
                  <div className="text">
                    <p className="text-gray-600 leading-relaxed md:leading-loose text-base md:text-lg">
                      We provide digital experience services to startups and
                      small businesses. We help our clients succeed by creating
                      brand identities, digital experiences, and print
                      materials. Install any demo, plugin or template in a
                      matter of seconds. Just select the demo and click OK. It&apos;s
                      that easy! The latest design trends meet hand-crafted
                      templates in Ave Collection. Use pre-built sections to
                      speed up your design process. Open a beautiful store,
                      increase your conversion rates and boost your sales in
                      minutes with object-oriented UX.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="img mb-12 md:mb-16 lg:mb-20 overflow-hidden rounded-lg md:rounded-xl shadow-lg">
              <img 
                src="https://images.unsplash.com/photo-1617396900799-f4ec2b43c7ae?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
                alt="" 
                className="w-full h-64 md:h-80 lg:h-96 object-cover"
              />
            </div>
            <div className="cont md:pt-16 border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
                <div className="md:col-span-3 mb-8 md:mb-0">
                  <h6 className="text-xl md:text-2xl lg:text-3xl font-semibold text-gray-800">The Story</h6>
                </div>
                <div className="md:col-span-9">
                  <div className="text">
                    <p className="text-gray-600 leading-relaxed md:leading-loose text-base md:text-lg">
                      We provide digital experience services to startups and
                      small businesses. We help our clients succeed by creating
                      brand identities, digital experiences, and print
                      materials. Install any demo, plugin or template in a
                      matter of seconds. Just select the demo and click OK. It&apos;s
                      that easy! The latest design trends meet hand-crafted
                      templates in Ave Collection. Use pre-built sections to
                      speed up your design process. Open a beautiful store,
                      increase your conversion rates and boost your sales in
                      minutes with object-oriented UX.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Story;
